module.exports = __webpack_public_path__ + "static/media/delete_disable.18be5484.svg";